<div>
  @if (errorMsg.length > 0) {
    <label class="tw:text-danger">{{errorMsg}}</label>
  }
  <form [formGroup]="frmSearch">
    <div class="flex-search-container" [class.filter-bar]="filtersEnabled">
      <div fxLayout="column" fxLayout.gt-md="row" fxLayoutWrap fxLayoutGap="1%" class="flex-search-sub filter-bar__group">
        <div fxLayout.gt-md="column" class="divFull filter-bar__field">
          <label class="field__label">Learner</label>
          <app-searchable-select multiple [items]="studentData"
            placeholder="Learner" searchPlaceholder="Search…"
            (selectionChange)="studentChanged($event)"></app-searchable-select>
        </div>
      </div>
      <div fxLayout="column" fxLayout.gt-md="row" fxLayoutWrap fxLayoutGap="1%" class="flex-search-sub filter-bar__group">
        <div fxLayout.gt-md="column" class="divFull filter-bar__field">
          <label class="field__label">Task</label>
          <app-searchable-select multiple [items]="taskData" placeholder="Task"
            searchPlaceholder="Search…" (selectionChange)="taskChanged($event)"></app-searchable-select>
        </div>
      </div>
      @if (filtersEnabled) {
        <div fxLayout="column" fxLayout.gt-md="row" fxLayoutWrap fxLayoutGap="1%" class="flex-search-sub filter-bar__group">
          <div fxLayout.gt-md="column" class="divFull filter-bar__group">
            <app-brand-filter class="filter-bar__field" [companyIds]="companyIds" (companyIdsChange)="brandsChanged($event)"></app-brand-filter>
          </div>
        </div>
        <div fxLayout="column" fxLayout.gt-md="row" fxLayoutWrap fxLayoutGap="1%" class="flex-search-sub filter-bar__group">
          <div fxLayout.gt-md="column" class="filter-bar__field filter-bar__field--check">
            <label class="field__toggle" id="assignedToMeFilter"><input type="checkbox" [checked]="assignedToMe"
              (change)="assignedToMe = $any($event.target).checked" /><span class="field__toggle-track"></span> Assigned to me</label>
          </div>
        </div>
        <div fxLayout="column" fxLayout.gt-md="row" fxLayoutWrap fxLayoutGap="1%" class="flex-search-sub filter-bar__group">
          <div fxLayout.gt-md="column" class="filter-bar__field">
            <label class="field__label" for="actionStatusFilter">Status</label>
            <select class="field__control" id="actionStatusFilter" [value]="status"
              (change)="status = $any($event.target).value">
              <option value="open">Open</option>
              <option value="done">Done</option>
              <option value="all">All</option>
            </select>
          </div>
        </div>
        <div fxLayout="column" fxLayout.gt-md="row" fxLayoutWrap fxLayoutGap="1%" class="flex-search-sub filter-bar__group">
          <div fxLayout.gt-md="column" class="filter-bar__field filter-bar__field--check">
            <label class="field__toggle" id="overdueFilter" [title]="'Open actions raised more than ' + overdueDays + ' days ago'"><input type="checkbox" [checked]="overdue"
              (change)="overdue = $any($event.target).checked" /><span class="field__toggle-track"></span> Overdue ({{overdueDays}}+ days)</label>
          </div>
        </div>
      }
      <div fxLayout="column" fxLayout.gt-md="row" fxLayoutWrap fxLayoutGap="1%" class="flex-search-sub filter-bar__group">
        @if (this.showSearchExtraColumns) {
          <div fxLayout.gt-md="column" class="filter-bar__field">
            <div>
              <label class="field__label">Client Referrer</label>
              <app-typeahead inputClass="field__control body-content" placeholder="Client Referrer" formControlName="clientReferrer"
                data-toggle="tooltip" data-placement="top" title="Please enter the client referrer"
                [enabled]="autocompleteEnabled" [source]="referrerNames"></app-typeahead>
            </div>
            </div>
          }
          @if (this.showSearchExtraColumns) {
            <div fxLayout.gt-md="column" class="filter-bar__field">
              <div>
                <label class="field__label">Client</label>
                <app-typeahead inputClass="field__control body-content" placeholder="Client" formControlName="client"
                  data-toggle="tooltip" data-placement="top" title="Please enter the client name"
                  [enabled]="autocompleteEnabled" [source]="clientNames"></app-typeahead>
              </div>
              </div>
            }
            @if (this.showSearchExtraColumns) {
              <div fxLayout.gt-md="column" class="filter-bar__field">
                <div>
                  <label class="field__label">Tutor</label>
                  <app-typeahead inputClass="field__control body-content" placeholder="Tutor" formControlName="tutor"
                    data-toggle="tooltip" data-placement="top" title="Please enter the tutor name"
                    [enabled]="autocompleteEnabled" [source]="tutorNames"></app-typeahead>
                </div>
                </div>
              }
              @if (this.showSearchExtraColumns) {
                <div fxLayout.gt-md="column" class="filter-bar__field">
                  <crm-user-select (onSelectedItemChanged)="onUserDataChanged($event)"></crm-user-select>
                </div>
              }
            </div>
            <div fxLayout="column" fxLayout.gt-md="row" fxLayoutWrap fxLayoutGap="1%" class="flex-search-sub filter-bar__group">
              <div fxLayout.gt-md="column" class="filter-bar__field">
                <div>
                  <label class="field__label">Date From</label>
                  <input type="date" class="field__control" formControlName="startDate" (input)="datePreset = null"
                    data-toggle="tooltip" data-placement="top" title="Please select the from date">
                  @if (frmSearch.controls.startDate.invalid && frmSearch.controls.startDate.touched) {
                    <span class="field__error">Enter Date From</span>
                  }
                  </div>
                </div>
                <div fxLayout.gt-md="column" class="filter-bar__field">
                  <div>
                    <label class="field__label">Date To</label>
                    <input type="date" class="field__control" formControlName="endDate" (input)="datePreset = null"
                      data-toggle="tooltip" data-placement="top" title="Please select the to date">
                    @if (frmSearch.controls.endDate.invalid && frmSearch.controls.endDate.touched) {
                      <span class="field__error">Enter Date To</span>
                    }
                    </div>
                  </div>
                  @if (!filtersEnabled) {
                    <div fxLayout.gt-md="column">
                      <div><label class="field__label tw:invisible">&nbsp;</label></div>
                      <button class="btn-outline-primary btn" style="height: 38px;" name="Search" value="Search" (click)="search()">Search</button>
                    </div>
                  }
                </div>
                @if (filtersEnabled) {
                  <div class="filter-bar__actions">
                    <div class="filter-bar__presets">
                      <app-date-presets [selected]="datePreset" (presetSelected)="onDatePreset($event)"></app-date-presets>
                    </div>
                    <div class="filter-bar__buttons">
                      <app-filter-clear-all (clear)="clearAll()"></app-filter-clear-all>
                      <button class="btn btn-primary" name="Search" value="Search" (click)="search()">Search</button>
                    </div>
                  </div>
                }
              </div>
            </form>
          </div>
